import React from "react"
import Popper from "@mui/material/Popper"
import Paper from "@mui/material/Paper"
import ClickAwayListener from "@mui/material/ClickAwayListener"
import Button from "@mui/material/Button"
import { RESERVATION_COLORS, STATUS_CONFIRMED, STATUS_WALK_IN } from "@/constants/reservations"
import i18n from "@/i18n"

interface SelectionPopoverProps {
  open: boolean
  anchorEl: HTMLElement | null
  startTime: string
  endTime: string
  onReserve: () => void
  onWalkIn: () => void
  onClose: () => void
}

const SelectionPopover: React.FC<SelectionPopoverProps> = ({
  open,
  anchorEl,
  startTime,
  endTime,
  onReserve,
  onWalkIn,
  onClose,
}) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="right"
      sx={{ zIndex: 100 }}
      data-testid="panel-reservations-calendar-selection-popover"
    >
      <ClickAwayListener onClickAway={onClose} mouseEvent="onMouseUp">
        <Paper className="p-4 shadow-lg bg-gray-100 rounded-lg min-w-64">
          <div className="text-center text-gray-700 font-medium mb-4">
            {startTime} - {endTime}
          </div>
          <div className="flex flex-col gap-2">
            <Button
              variant="contained"
              fullWidth
              onClick={onReserve}
              data-testid="panel-reservations-calendar-selection-popover-reserve-btn"
              sx={{
                backgroundColor: RESERVATION_COLORS[STATUS_CONFIRMED].main,
                "&:hover": {
                  backgroundColor: RESERVATION_COLORS[STATUS_CONFIRMED].dark,
                },
                textTransform: "none",
                py: 1.5,
              }}
            >
              {i18n.t("app.calendar.selection.reserve_table")}
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={onWalkIn}
              data-testid="panel-reservations-calendar-selection-popover-walkin-btn"
              sx={{
                backgroundColor: RESERVATION_COLORS[STATUS_WALK_IN].main,
                color: "black",
                "&:hover": {
                  backgroundColor: RESERVATION_COLORS[STATUS_WALK_IN].dark,
                },
                textTransform: "none",
                py: 1.5,
              }}
            >
              {i18n.t("app.calendar.selection.seat_table")}
            </Button>
          </div>
        </Paper>
      </ClickAwayListener>
    </Popper>
  )
}

export default SelectionPopover
